const BundleProduct = {
  log: window.log,
  selectedVariants: new Map(), // Store selected variants for each product

  init() {
    this.setupEventListeners();
    this.initializeSelections();
    this.updatePrices();
  },

  setupEventListeners() {
    // Popup functionality
    $(document).on('click', '.pdp-main-bundle__product-learn-more, .pdp-main-bundle__gift', (e) => {
      const $element = $(e.target);
      const descriptionId = $element.data('description-id');
      const descriptionHtml = descriptionId ? $(`.${descriptionId}`).html() : '';

      this.updatePopupContent({
        title: $element.data('title'),
        description: descriptionHtml,
        image: $element.data('image')
      });
    });

    // Handle variants position
    this.handleVariantsPosition();
    $(window).on('resize', this.handleVariantsPosition.bind(this));

    // Variant selection listeners
    $('.pdp-main-bundle__product-container').each((_, container) => {
      const $container = $(container);
      const productId = $container.data('product-id');

      $container.find('.main-select__item').click((e) => {
        // Update selected variant and prices
        const isColorSelect = $(e.target).closest('.main-select__item').hasClass('color');
        this.updateSelectedVariant(productId, isColorSelect);
        this.updatePrices();
      });
    });

    // Add to cart
    $('.pdp-main-bundle__atc-btn').click((e) => {
      e.preventDefault();
      this.addToCart();
    });

    // Sync bundle sizes with main product size selection
    $(document).on('change', 'select.pdp-main__product-options-select[data-type="size"]', (e) => {
      const selectedSize = $(e.target).val();
      $(`.pdp-main-bundle__product-container`).each((_, container) => {
        const $sizeSelect = $(container).find('.main-select[data-type="size"]');
        const $matchingSizeItem = $sizeSelect.find(`.main-select__item[data-value="${selectedSize}"]`);
        if ($matchingSizeItem.length) {
          $matchingSizeItem.click();
        }
      });
    });
  },

  initializeSelections() {
    $('.pdp-main-bundle__product-container').each((_, container) => {
      const productId = $(container).data('product-id');
      this.updateSelectedVariant(productId);
    });
  },

  updateSelectedVariant(productId, isColorSelect = false) {
    const $container = $(`.pdp-main-bundle__product-container[data-product-id="${productId}"]`);
    if (!$container.length) return;

    const $selectedColor = $container.find('.main-select__item.color[data-selected="true"]').first();
    const $selectedSize = $container.find('.main-select__item.size[data-selected="true"]').first();

    const color = $selectedColor.length ? $selectedColor.data('value') : $container.find('.main-select__item.color').first().data('value');
    const size = $selectedSize.length ? $selectedSize.data('value') : $container.find('.main-select__item.size').first().data('value');

    const variantData = this.findVariantData(productId, color, size);

    isColorSelect && this.updateImage(productId, variantData);

    if (variantData) {
      this.selectedVariants.set(productId, {
        color,
        size,
        variantId: variantData.id,
        price: variantData.price,
        comparePrice: variantData.comparePrice,
        available: variantData.available
      });
    }
  },

  findVariantData(productId, color, size) {
    const $variantData = $(`.bundle-variant-data__item[data-product-id="${productId}"]`);
    if (!$variantData.length) return null;

    let matchedVariant = null;
    $variantData.find('input[name="id"]').each((_, input) => {
      const $input = $(input);
      if ($input.data('color') === color && $input.data('size') === size) {
        matchedVariant = {
          id: parseInt($input.val()),
          price: parseInt($input.data('price')) || 0,
          comparePrice: parseInt($input.data('compare-price')) || 0,
          available: $input.data('available'),
          image: $input.data('image')
        };
        return false;
      }
    });

    return matchedVariant;
  },

  updateImage(productId, variantData) {
    const $container = $(`.pdp-main-bundle__product-container[data-product-id="${productId}"]`);
    if (!$container.length) return;
    const $image = $container.find('.pdp-main-bundle__product-image > img');
    $image.attr('srcset', variantData.image + ' 100w');
  },

  updatePopupContent(data) {
    const $popup = $('#pdp-main-popup');
    if (!$popup.length) return;

    $popup.find('#popup-image').attr({ src: data.image || '', alt: data.title || '' });
    $popup.find('#popup-title').text(data.title || '');
    $popup.find('#popup-description').html(data.description || '');
  },

  handleVariantsPosition() {
    const w = window.innerWidth;
    $('.pdp-main-bundle__product-container').each((_, c) => {
      const $c = $(c);
      const $variants = $c.find('.pdp-main-bundle__product-variants');
      const $content = $c.find('.pdp-main-bundle__product-content');
      if (!$variants.length) return;

      const shouldBeParent = ((w >= 768 && w < 1023) || w >= 1280) && $content.length ? $content[0] : $c[0];
      if ($variants.parent()[0] !== shouldBeParent) {
        $(shouldBeParent).append($variants);
      }
    });
  },

  calculateTotals() {
    let totalPrice = 0;
    let totalComparePrice = 0;
    const bundleDiscount = parseInt($('.pdp-main-bundle__products').data('bundle-discount')) || 0;

    // Calculate product prices
    this.selectedVariants.forEach((variantData, productId) => {
      if (variantData && variantData.available) {
        const price = variantData.price;
        const priceSaved = price * bundleDiscount / 100;
        totalPrice += price - priceSaved;
        totalComparePrice += variantData.comparePrice > variantData.price ? variantData.comparePrice : variantData.price;
      }
    });

    // Add gift compare prices
    $('.pdp-main-bundle__gift').each((_, gift) => {
      const $gift = $(gift);
      const giftId = $gift.data('gift-id');
      const hasSizeOptions = $gift.data('has-size-options');

      // Get main product size
      const firstProductId = Array.from(this.selectedVariants.keys())[0];
      const mainProductSize = firstProductId ? this.selectedVariants.get(firstProductId)?.size : null;

      const giftVariantId = this.getGiftVariantId(giftId, hasSizeOptions, mainProductSize);
      if (giftVariantId) {
        const $giftVariantData = $(`.bundle-gift-variant-data__item[data-gift-id="${giftId}"]`);
        const $giftVariant = $giftVariantData.find(`input[name="gift-variant-id"][value="${giftVariantId}"]`);
        if ($giftVariant.length) {
          const giftComparePrice = parseInt($giftVariant.data('compare-price')) || 0;
          totalComparePrice += giftComparePrice;
        }
      }
    });

    return { totalPrice, totalComparePrice };
  },

  getGiftVariantId(giftId, hasSizeOptions, mainProductSize) {
    const $giftVariantData = $(`.bundle-gift-variant-data__item[data-gift-id="${giftId}"]`);
    if (!$giftVariantData.length) return null;

    // Get default color from first input
    const $firstInput = $giftVariantData.find('input[name="gift-variant-id"]').first();
    const defaultColor = $firstInput.data('first-color');

    let matchingVariantId = null;
    let firstColorVariantId = null;

    $giftVariantData.find('input[name="gift-variant-id"]').each((_, input) => {
      const $input = $(input);
      const variantSize = $input.data('size');
      const variantColor = $input.data('color');
      const isAvailable = $input.data('available');

      // Store first available variant for default color
      if (isAvailable && variantColor === defaultColor && !firstColorVariantId) {
        firstColorVariantId = $input.val();
      }

      // Look for matching size with default color
      if (hasSizeOptions && mainProductSize && variantSize === mainProductSize && isAvailable && variantColor === defaultColor) {
        matchingVariantId = $input.val();
        return false;
      }
    });

    return matchingVariantId || firstColorVariantId;
  },

  updatePrices() {
    const totals = this.calculateTotals();
    const $atcBtn = $('.pdp-main-bundle__atc-btn');
    const $priceSpan = $atcBtn.find('span.money');
    const $compareSpan = $atcBtn.find('s.money-compare');

    if ($priceSpan.length) $priceSpan.text(this.formatMoney(totals.totalPrice));
    if ($compareSpan.length && totals.totalComparePrice > totals.totalPrice) {
      $compareSpan.text(this.formatMoney(totals.totalComparePrice));
    }
  },

  formatMoney(cents) {
    const currency = $('.bundle-variant-data').data('currency')?.replace('0.00', '').replace('0,00', '') || '£';
    return `${currency}${(cents / 100).toFixed(2)}`;
  },

  collectBundleItems() {
    const items = [];
    const bundleId = $('.bundle-variant-data').data('bundle-id');

    // Add product variants
    this.selectedVariants.forEach((variantData, productId) => {
      if (variantData && variantData.available) {
        items.push({ id: variantData.variantId, quantity: 1, properties: { '_bundle_id': bundleId } });
      }
    });

    // Add gift variants
    $('.pdp-main-bundle__gift').each((_, gift) => {
      const $gift = $(gift);
      const giftId = $gift.data('gift-id');
      const hasSizeOptions = $gift.data('has-size-options');

      const firstProductId = Array.from(this.selectedVariants.keys())[0];
      const mainProductSize = firstProductId ? this.selectedVariants.get(firstProductId)?.size : null;

      const giftVariantId = this.getGiftVariantId(giftId, hasSizeOptions, mainProductSize);
      if (giftVariantId) {
        items.push({ id: giftVariantId, quantity: 1, properties: { '_bundle_id': bundleId } });
      }
    });

    return items;
  },

  addToCart() {
    const items = this.collectBundleItems();
    if (items.length === 0) {
      alert('No items to add to cart.');
      return;
    }

    // Show loading state
    const $button = $('.pdp-main-bundle__atc-btn');
    const $text = $button.find('span[data-main-text]');
    const originalText = $text.text();
    $text.text('Adding...');
    $button.prop('disabled', true);

    $.post('/cart/add.js', { items })
      .done(() => {
        window.cart_open();
        window.cart_build();
      })
      .fail(() => alert('Error adding item to cart.'))
      .always(() => {
        $text.text(originalText);
        $button.prop('disabled', false);
      });
  }
};

// Initialize when DOM is ready
$(document).ready(() => {
  BundleProduct.init();
}); 